import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { BottomNavComponent } from './bottom-nav/bottom-nav.component';
import { BottomNavButtonComponent } from './bottom-nav-button/bottom-nav-button.component';

@NgModule({
  declarations: [
    BottomNavComponent,
    BottomNavButtonComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatRippleModule,
    MatToolbarModule,
    RouterModule
  ],
  exports: [
    BottomNavComponent,
    BottomNavButtonComponent
  ]
})
export class ComponentsModule {}
